module.exports = __webpack_public_path__ + "img/img-works_5.8c6dc4c6.png";